import { makeStyles } from "@material-ui/core";
import { colors } from "~/utils/colors";

const { white, brand } = colors;

const MuiStylesCancellationSuccessModal = makeStyles((theme) => ({
	dialogPaper: {
		borderRadius: "20px",
		maxWidth: "400px",
		width: "90%",
		margin: "16px",
		boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
	},
	dialogContent: {
		padding: "32px 24px",
		textAlign: "center",
	},
	headerSection: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginBottom: "24px",
		gap: "12px",
	},
	title: {
		fontSize: "20px",
		fontWeight: "bold",
		color: "#333333",
		margin: 0,
	},
	successIconContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	successIcon: {
		fontSize: "28px",
		color: "#4CAF50",
	},
	bodySection: {
		marginBottom: "32px",
	},
	message: {
		fontSize: "16px",
		color: "#666666",
		lineHeight: "1.5",
		textAlign: "center",
	},
	actionButtons: {
		display: "flex",
		flexDirection: "row",
		gap: "8px",
		padding: "0 24px 24px",
		justifyContent: "center",
		alignItems: "center",
	},
	scheduleButton: {
		backgroundColor: brand?.default,
		padding: "10px 16px",
		color: white,
		height: 44,
		fontSize: "14px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "25.5px",
		flex: 1,
		cursor: "pointer",
		textTransform: "none",
		minWidth: 0,
		"&:active": {
			backgroundColor: "#DC143C",
			color: "white",
		},
	},
	viewReservationsButton: {
		backgroundColor: "transparent",
		padding: "10px 16px",
		color: "#222",
		height: 44,
		fontSize: "14px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "25.5px",
		flex: 1,
		border: "1px solid #222",
		cursor: "pointer",
		textTransform: "none",
		minWidth: 0,
		"&:active": {
			backgroundColor: "#DC143C",
			color: "white",
		},
	},
}));

export default MuiStylesCancellationSuccessModal;
